module.exports = __webpack_public_path__ + "static/img/PT@3x.e6b93577.png";